// extracted by mini-css-extract-plugin
export default {"login":"Login_login__xa8qr","input":"Login_input__Ei6Hl","form":"Login_form__7ESuZ","info":"Login_info__nrm6r","register":"Login_register__URKdK","icon":"Login_icon__9CCXp"};